/**
 * Watershed — front-end entry
 */

import scrollButtons from './scroll-button';
import numbers from './numbers';
import donuts from './donut';
import funderDropdowns from './funder-dropdown';
import smoothScroll from './smooth-scroll';
import reveal from './reveal';
import readMore from './read-more';
import rivers from './rivers';

document.documentElement.classList.add('js');

smoothScroll();

scrollButtons();
donuts();
numbers();
funderDropdowns();
reveal();
readMore();
rivers();

// Mobile menu toggle
const toggle = document.querySelector<HTMLButtonElement>('.menu-toggle');
toggle?.addEventListener('click', () => {
  const open = document.body.classList.toggle('menu-open');
  toggle.setAttribute('aria-expanded', String(open));
});
